var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_content-media-list pt-2" },
    _vm._l(_vm.mediasFormatted, function (media, position) {
      return _c(
        "div",
        {
          key: position,
          class: [
            "_content-media-item",
            _vm.actionOnClick ? "active-border cursor-pointer" : "",
          ],
        },
        [
          _c(
            "div",
            {
              staticClass: "_content-media",
              on: {
                click: function ($event) {
                  return _vm.clickedMedia(media)
                },
              },
            },
            [
              _vm._t("prepend", null, { media: media }),
              _c("div", { staticClass: "_content-media-icon" }, [
                _vm.hasThumbnail(media)
                  ? _c("div", { staticClass: "_content-media-thumbnail" }, [
                      _c("img", {
                        staticClass: "w-full h-full",
                        attrs: { src: _vm.getMediaThumbnailUrl(media) },
                      }),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass:
                          "w-full h-full flex items-center justify-center grid",
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "h-8 w-8 m-auto",
                          attrs: { icon: "file" },
                        }),
                        _c("small", [
                          _vm._v(_vm._s(_vm.getMediaSubtitle(media))),
                        ]),
                      ],
                      1
                    ),
              ]),
              _c(
                "div",
                { staticClass: "_content-media-text grid flex items-center" },
                [
                  _vm._t(
                    "title",
                    function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "_content-media-title break-all" },
                          [_vm._v(" " + _vm._s(_vm.getMediaTitle(media)) + " ")]
                        ),
                      ]
                    },
                    { media: media }
                  ),
                ],
                2
              ),
              _c("div", { staticClass: "_content-media-action" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-full h-full flex items-center justify-center pr-1 mr-5",
                  },
                  [
                    _c("font-awesome-icon", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Baixar",
                          expression: "'Baixar'",
                        },
                      ],
                      staticClass: "h-5 w-5 m-auto hover:text-success",
                      attrs: { icon: _vm.getMediaActionIcon(media) },
                      on: {
                        click: function () {
                          return _vm.actionOnClick
                            ? undefined
                            : _vm.mediaAction(media, position)
                        },
                      },
                    }),
                    _vm.showDelete
                      ? _c("font-awesome-icon", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Excluir",
                              expression: "'Excluir'",
                            },
                          ],
                          staticClass: "h-5 w-5 m-auto hover:text-danger",
                          attrs: { icon: "times" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmOnDelete(media)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }